import { FC } from "react";
import CommonButton from "components/common/ui/CommonButton";
import { Box, Grid } from "@mui/material";

interface MenuEditActionButtonsProps {
  onCreate: VoidFunction;
  onUpdate: VoidFunction;
  onDelete: VoidFunction;
  hideSaveAsNew?: boolean;
  hideDelete?: boolean;
}

const MenuEditActionButtons: FC<MenuEditActionButtonsProps> = ({
  onCreate,
  onUpdate,
  onDelete,
  hideSaveAsNew = false,
  hideDelete = false,
}) => {
  return (
    <Grid container>
      <Grid item xs={8}>
        <CommonButton text="Save" positive onClick={onUpdate} />
        {!hideSaveAsNew && (
          <CommonButton text="Save As New" positive onClick={onCreate} />
        )}
      </Grid>
      <Grid item xs={4}>
        <Box display="flex" justifyContent="flex-end">
          {!hideDelete && (
            <CommonButton text="Delete" danger onClick={onDelete} />
          )}
        </Box>
      </Grid>
    </Grid>
  );
};

export default MenuEditActionButtons;
